import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { all_routes } from "../../router/all_routes";
import useApi from "../../../core/customhook/useApi";

const CareerAspirations = () => {
  const navigate = useNavigate();
  const { financial_year } = useParams();
  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };
  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());

  const [aspiration, setAspiration] = useState("");
  const {
    data: getcomaspidetails,
    loading: comaspidetailsLoading,
    error: comaspidetailsError,
  } = useApi("/api/view-comments-aspiration", {
    method: "POST",
    payload: {
      financial_year: financial_year,
      category_id: localStorage.getItem("pms_category_id"),
    },
    autoCall: true,
  });
  useEffect(() => {
    if (getcomaspidetails?.success) {
      setAspiration(getcomaspidetails?.data?.employee_carrier_aspiration);
    }
  }, [getcomaspidetails]);

  const {
    data: addComAspiRatingdetails,
    loading: addComAspiRatingdetailsLoading,
    error: addComAspiRatingdetailsError,
    callApi: AddRaitingComAspi,
  } = useApi("/api/add-comments-aspiration", {
    method: "POST",
    autoCall: false,
  });

  const handleSaveOrSubmitComAspi = async (e: any) => {
    e.preventDefault();
    const payload = {
      status: "E Submit",
      category_id: localStorage.getItem("pms_category_id"),
      aspiration: aspiration,
      financial_year: financial_year,
    };
    console.log(payload);
    if (payload.status === "E Submit") {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Once you submit the goals settings, you won't be able to make any changes.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, submit",
        cancelButtonText: "Cancel",
      });

      if (!result.isConfirmed) {
        return;
      }
    }
    try {
      const response = await AddRaitingComAspi(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/pms-Grid");
        localStorage.removeItem("pms_category_id");
        localStorage.removeItem("pms_category_name");
      }
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Career Aspirations</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.adminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Work & Operations</li>
                <li className="breadcrumb-item">Goal Settings</li>
                <li className="breadcrumb-item active" aria-current="page">
                  Career Aspirations
                </li>
              </ol>
            </nav>
          </div>
          <div className="head-icons ms-2">
            <CollapseHeader />
          </div>
        </div>

        {/* Form Card */}
        <div className="card mb-4">
          <div className="card-header">
            <h5>Tell us about your Career Aspirations</h5>
          </div>
          <div className="card-body">
            <form
              onSubmit={(e) => {
                handleSaveOrSubmitComAspi(e);
              }}
            >
              <div className="mb-3">
                <label className="form-label">
                  Career Aspiration<sup className="text-danger">*</sup>
                </label>
                <textarea
                  className="form-control"
                  rows={10}
                  placeholder="Write your aspirations here..."
                  value={aspiration}
                  onChange={(e) => setAspiration(e.target.value)}
                  required
                ></textarea>
              </div>

              <div className="d-flex justify-content-end me-2">
                <div className="d-flex gap-2">
                  <Link
                    to="/pms-behavioural-Competence"
                    className="btn btn-outline-secondary"
                  >
                    <i className="bi bi-arrow-left ms-2"></i>Back
                  </Link>
                  <button
                    type="submit"
                    className="btn btn-primary custom_button"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
        <p className="mb-0">
          © {new Date().getFullYear()} WeConnect. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default CareerAspirations;
